import axios, { AxiosResponse } from 'axios';
import { CommonService } from './common.services';
import { ArchivoAcreditado } from './suite.interfaces';

export class ArchivoAcreditadoService extends CommonService {

  async saveOrReplace(evento: number, idAcreditado: number, archivoAcreditado: ArchivoAcreditado) {
    try {
      const archivos = { "archivosAcreditado": [archivoAcreditado] };
      const response: AxiosResponse<String> = await axios.post(super.getServerUrl() + '/mobile/saveOrReplace?evento=' + evento + '&id=' + idAcreditado, archivos, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return (response.data as string == "Ok");
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findServerPathArchivoAcreditadoBy(evento: number, idAcreditado: number, tipoArchivo: number): Promise<String> {
    try {
      const response: AxiosResponse<String> = await axios.get(super.getServerUrl() + '/mobile/findServerPathArchivoAcreditadoBy?evento=' + evento + '&id=' + idAcreditado + '&idTipoArchivo=' + tipoArchivo, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

}
